<template>
  <section id="SectionPriceProcess">
    <Wrap class="lg">
      <h2 class="title">
        {{ $t('title') }}
      </h2>
      <div class="block process">
        <Pic
          alt="Bigbank calculator"
          draggable="false"
          src="../../assets/process.png" />
        <!-- <div class="process-content">
          <div class="list-label">
            {{ $t('process.label') }}
          </div>
          <ol>
            <li v-for="item in $ta('process.items')" :key="item">
              {{ item }}
            </li>
          </ol>
        </div> -->
      </div>
    </Wrap>
  </section>
</template>

<script>
import { mergeLabels } from '../../../utils'

export default {
  data() {
    return {
      legendColors: [
        { color: '#D7F4FF' },
        { color: '#9CEAFB' },
        { color: '#32BDE5' },
        { color: '#74D0F9' },
        { color: '#008FB8' },
      ],
    }
  },
  computed: {
    legends() {
      return mergeLabels(this.legendColors, this.$ta('price.legends'))
    },
  },
}
</script>

<style lang="scss">
#SectionPriceProcess {
  .title {
    padding-bottom: 3rem;
  }

  img {
    width: 100%;
  }

  .block {
    background-color: $white;
    margin-bottom: 2rem;
    padding: 1rem 2rem;

    .process-content {
      margin: 3rem 0 0 2rem;

      .list-label {
        font-weight: $bold;
        margin-bottom: 1rem;
      }

      li {
        color: $grey;
        margin-left: 1rem;
        padding: 1rem 0 1rem 2rem;
      }
    }
  }

  .process {
    background-color: inherit;
  }

}
</style>

<i18n>
{
    "lt": {
        "title": "Procesas",
        "price": {
            "title": "Kaina",
            "legends": [
                "40% modulių kaina;",
                "35% inverteris ir optimizatoriai;",
                "15% įrengimo darbai;",
                "8% konstrukcijos;",
                "2% kabeliai;"
            ]
        },
        "process": {
            "title": "Procesas",
            "label": "Saulės elektrinės įrengimo procesas:",
            "items": [
                "Įvertiname objektą: elektros sąnaudas, stogo kryptį, plotą ir kt.",
                "Pateikiame pasiūlymą",
                "Pasirašome sutartį",
                "Apsilankome objekte (išmatuojame stogą dronu ir įvertiname vidinį tinklą)",
                "Tvirtinimasis modulių išdėstymas ant namo stogo (atsiunčiame 3D vizualizaciją)",
                "Sumontuojame elektrinę",
                "Saulės elektrinė prijungiama prie ESO tinklų"
            ]
        }

    }
}
</i18n>
